/*
// Licensed Materials - Property of HCL
// (C) Copyright HCL Technologies Limited 2001, 2021
// All Rights Reserved
*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createFilterManagerFromReduxState } from '../../../BfFilterManager'
import { updateFilterListUrlAction } from '../../../../redux/BfFilterListUpdateURLAction'
import { BfDataGridComponentWithContext } from '../../../../BfDataGridContext'

const BfGenericFilterWithReduxAction = (WrappedComponent) => {
  class BfGenericFilterWithActionClass extends Component {
    _handleOnChange = (data) => {
      this.props.updateFilterListUrlAction(this.props.id, data)
    }

    render() {
      return <WrappedComponent filter={this.props.filter} onChange={this._handleOnChange} id={this.props.id} />
    }
  }
  return connect(mapStateToProps, {
    updateFilterListUrlAction
  })(BfDataGridComponentWithContext(BfGenericFilterWithActionClass))
}

const mapStateToProps = (state, ownProps) => {
  const bfFilterManager = createFilterManagerFromReduxState(state, ownProps.id)

  return {
    filter: bfFilterManager.getFilterFromURLByName(ownProps.filterName)
  }
}

export default BfGenericFilterWithReduxAction
